import { IconProps } from "../../../types/style";

const ShieldSecuritySVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.54 4.17008L13.04 2.11008C12.47 1.90008 11.54 1.90008 10.97 2.11008L5.47005 4.17008C4.41005 4.57008 3.55005 5.81008 3.55005 6.94008V15.0401C3.55005 15.8501 4.08005 16.9201 4.73005 17.4001L10.23 21.5101C11.2 22.2401 12.79 22.2401 13.76 21.5101L19.26 17.4001C19.91 16.9101 20.4401 15.8501 20.4401 15.0401V6.94008C20.4501 5.81008 19.59 4.57008 18.54 4.17008ZM12.75 12.8701V15.5001C12.75 15.9101 12.41 16.2501 12 16.2501C11.59 16.2501 11.25 15.9101 11.25 15.5001V12.8701C10.24 12.5501 9.50005 11.6101 9.50005 10.5001C9.50005 9.12008 10.62 8.00008 12 8.00008C13.38 8.00008 14.5 9.12008 14.5 10.5001C14.5 11.6201 13.76 12.5501 12.75 12.8701Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default ShieldSecuritySVG;
